import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With over 26 years of experience in risk management and banking, what key moments
                have shaped your career, and what leadership principles guide your approach to
                managing risk at Bank of Khartoum?
              </strong>
            </h5>

            <h5 className="text-white">
              With over 26 years of experience in risk management and banking, my career has been
              shaped by key moments that reinforced the importance of strategic risk management,
              regulatory adaptability, and leadership resilience. Earning highest academic
              qualifications and attending various leadership programs in banking have significantly
              contributed to my analytical and decision-making abilities. One pivotal moment was
              navigating the 2008 global financial crisis, which underscored the importance of
              proactive risk assessment and stress testing. Another defining experience was leading
              risk transformation initiatives at key financial institutions, where I developed
              frameworks that balanced regulatory compliance with business growth. At Bank of
              Khartoum, my leadership approach is guided by principles of foresight, collaboration,
              and integrity. I emphasize a risk-aware culture, leveraging data-driven
              decision-making, and aligning risk strategies with the bank’s long-term vision. By
              fostering strong governance and empowering teams with continuous learning, I ensure
              that risk management is not just a function but a value-driven approach that supports
              sustainable banking.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- You have been instrumental in implementing enterprise risk management (ERM)
                frameworks and corporate governance best practices. How do you balance regulatory
                compliance with strategic business growth?
              </strong>
            </h5>
            <h5 className="text-white">
              Implementing Enterprise Risk Management (ERM) across both banking and non-banking
              organizations has given me a deep understanding of balancing regulatory compliance
              with strategic business growth. I believe that effective risk management should not be
              seen as a constraint but as an enabler of sustainable success. To achieve this
              balance, I take a proactive approach by integrating ERM into the organization’s
              strategic decision-making process. This involves aligning risk appetite with business
              objectives, ensuring compliance enhances rather than hinders growth. By fostering a
              strong risk culture and embedding governance best practices, I help organizations
              anticipate challenges, optimize opportunities, and drive innovation within a
              controlled environment. At the core of my strategy is leveraging data analytics and
              advanced risk assessment tools to provide real-time insights. This not only ensures
              adherence to regulatory requirements but also supports informed decision-making that
              fuels expansion and financial stability. Additionally, I prioritize collaboration
              between risk management teams and business units, ensuring a shared vision where
              compliance and growth go hand in hand.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With the evolving regulatory landscape, how has Basel III and IFRS9 impacted
                banking risk management strategies?
              </strong>
            </h5>
            <h5 className="text-white">
              The evolving regulatory landscape, particularly Basel III and IFRS 9, has transformed
              banking risk management by emphasizing capital adequacy, liquidity, and
              forward-looking risk assessment. These frameworks are not just about compliance; they
              provide an opportunity to build a stronger, more resilient banking sector. We are in
              line with the regulatory requirements.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Given your expertise in operational risk, what are the biggest emerging risks in
                banking today, and how can institutions proactively mitigate them?
              </strong>
            </h5>
            <h5 className="text-white">
              Emerging risks in banking today are driven by cyber threats, regulatory changes,
              technological disruptions, and third-party dependencies. Cybersecurity risks are
              escalating with digital transformation, requiring advanced fraud detection and
              continuous threat monitoring. Increased reliance on third-party vendors introduces
              operational vulnerabilities, making due diligence and real-time oversight essential.
              Regulatory shifts, such as Basel III and data privacy laws, demand agility and
              proactive compliance strategies. The rapid adoption of AI and automation also presents
              ethical and operational challenges, necessitating responsible AI frameworks. To
              mitigate these risks, banks must adopt a holistic ERM approach, integrate risk
              intelligence into strategic planning, and leverage real-time data analytics to enhance
              resilience and sustainable growth.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You have successfully led major risk management projects with leading consultancy
                firms and served on various industry committees. What insights have these
                experiences provided on shaping risk management standards?
              </strong>
            </h5>
            <h5 className="text-white">
              Leading major risk management projects with top consultancy firms and serving on
              industry committees have given me a broad perspective on shaping risk management
              standards. These experiences have reinforced the importance of aligning risk
              frameworks with business strategy, regulatory expectations, and market dynamics.
              Collaboration with regulators, industry leaders, and financial institutions has
              provided valuable insights into best practices for building resilient risk cultures,
              enhancing governance, and leveraging technology for proactive risk identification. By
              integrating global standards with local market needs, I have helped organizations
              develop agile risk management frameworks that support both compliance and sustainable
              growth.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With the rise of fintech, digital banking, and AI-driven financial services, how
                do you see risk management evolving to address new technological challenges and
                opportunities?
              </strong>
            </h5>
            <h5 className="text-white">
              The rise of fintech, digital banking, and AI-driven financial services is transforming
              risk management, requiring a more adaptive and technology-driven approach. As digital
              innovation accelerates, new risks such as cybersecurity threats, data privacy
              concerns, and AI ethics must be proactively addressed. Risk management is evolving by
              leveraging advanced analytics, real-time monitoring, and AI-powered fraud detection to
              enhance resilience. At the same time, regulatory frameworks must keep pace with
              innovation to ensure compliance without stifling growth. By integrating technology
              into risk strategies, banks can not only mitigate emerging threats but also unlock new
              opportunities for efficiency, customer experience, and financial inclusion.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- Beyond your banking career, you have contributed extensively to academia and
                thought leadership. How has your research and book on operational risk management
                influenced industry practices?
              </strong>
            </h5>
            <h5 className="text-white">
              I hope my research and book on operational risk management have contributed to
              improving industry practices, though I may not be fully aware of their impact. My goal
              has always been to bridge the gap between theory and practice by providing insights
              that help financial institutions strengthen their risk management frameworks. I have
              aimed to enhance understanding of operational risks, governance, and regulatory
              alignment, integrating technology and data-driven strategies. Through my academic work
              and thought leadership, I have tried my best to support the evolution of risk
              management standards and encourage a more proactive approach to managing emerging
              challenges.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q- As a leader in risk management and governance, what advice would you give to
                aspiring professionals looking to build a career in banking risk and compliance?
              </strong>
            </h5>
            <h5 className="text-white">
              For aspiring professionals in banking risk and compliance, my advice is to develop a
              strong foundation in both technical knowledge and strategic thinking. Understanding
              regulatory frameworks, risk assessment methodologies, and financial analysis is
              essential, but equally important is the ability to adapt to evolving challenges. Stay
              curious, continuously learn, and embrace technological advancements like AI and data
              analytics, as they are reshaping risk management. Building a successful career also
              requires a proactive mindset—engage with industry developments, seek mentorship, and
              cultivate problem-solving skills. Integrity and ethical decision-making are
              fundamental, as trust is at the core of risk and compliance. Finally, view risk
              management not just as a control function but as a value-adding discipline that
              supports business growth and financial stability.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
